//Local Storage Object for Athena Website
export const AthenaSettingsKeys = {
    darkMode: "darkMode",
    isEmbed: "isEmbed",
    version: "version"
}

function AthenaSettings() {
    //default value
    this.value = {
        darkMode: false,
        isEmbed: true,
        version: 0
    };

    this.setItem = function(key, value) {
        this.value = {
            ...this.value,
            [key]: value
        };
        
        this._saveChanges();
    }

    this.getItem = function(key) {
        try {
            return this.value[key];
        } catch (_) {
            return null;
        }
    }

    this.refresh = () => {
        this._init();
    }

    this._saveChanges = function() {
        localStorage.setItem(AthenaSettings.key, JSON.stringify(this.value));
    }

    this._init = function() {
        const athenaSettings = localStorage.getItem(AthenaSettings.key);
        const parsedSettings = athenaSettings ? JSON.parse(athenaSettings) : {};

        //Checks if new key value added on default value
        if (Object.keys(parsedSettings) !== Object.keys(this.value)) {
            this.value = {
                ...this.value,
                ...parsedSettings
            };
        }
    }
    this._init();
}

AthenaSettings.key = "athenaKHSettings";

export default AthenaSettings;